var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitlabIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "62px",
    viewBox: "0 0 67 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gitlab-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gitlab-icon",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E24329",
    points: "32 58.964 43.784 22.687 20.216 22.687"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FC6D26",
    points: "32 58.964 20.216 22.687 3.7 22.687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,22.687 L0.12,33.717 C-0.206732458,34.7222517 0.150952724,35.8235668 1.006,36.445 L32,58.964 L3.7,22.687 Z",
    id: "Path",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,22.687 L20.215,22.687 L13.118,0.853 C12.753,-0.271 11.163,-0.271 10.798,0.853 L3.7,22.687 Z",
    id: "Path",
    fill: "#E24329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FC6D26",
    points: "32 58.964 43.784 22.687 60.3 22.687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3,22.687 L63.88,33.707 C64.2067325,34.7122517 63.8490473,35.8135668 62.994,36.435 L32,58.964 L60.3,22.687 Z",
    id: "Path",
    fill: "#FCA326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3,22.687 L43.784,22.687 L50.882,0.843 C51.247,-0.281 52.837,-0.281 53.202,0.843 L60.3,22.687 Z",
    id: "Path",
    fill: "#E24329"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabIcon);
export default __webpack_public_path__ + "static/media/gitlab-icon.71d83ed9cf00f5006aab295d9a36c4a0.svg";
export { ForwardRef as ReactComponent };